import { render, staticRenderFns } from "./InventoriesList.vue?vue&type=template&id=f46ce602"
import script from "./InventoriesList.vue?vue&type=script&lang=js"
export * from "./InventoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports